import PropTypes from 'prop-types';
import React from 'react';

const RecipientListName = ({ recipient, data }) => {
	const getColor = (recipient, documentStatus) => {
		const statusColorMap = {
			Draft: '#FFDA15',
			'Procurement InProgress': '#FFDA15',
			'Payment Pending': '#FFDA15',
			'Awaiting Signing': '#FFDA15',
			'Awaiting Approval': '#FFDA15',
			Signed: 'green',
			'Rejected Approval': '#f44336',
			'Procurement Failed': '#f44336',
			'Payment Failed': '#f44336',
			'Payment Expired': '#f44336',
			'Customer Rejected': '#f44336',
			'Signing Expired': 'grey',
			'Verification Failed': '#f44336',
			'eStamp Cancelled': '#f44336',
			'Rejected Edit Approval': '#f44336',
			'Rejected Cancel Approval': '#f44336',
			Cancelled: '#f44336'
		};

		if (recipient?.linkExpired) {
			return '#f44336';
		}

		if (recipient?.status === 'Signed') {
			return 'green';
		}

		const color = statusColorMap[documentStatus] || '#f44336';
		return color;
	};

	const color = getColor(recipient, data?.status);

	return (
		<>
			<div
				className='recipientsDetails'
				style={{
					backgroundColor: 'black',
					color,
					border: '2px solid',
					alignItems: 'center',
					boxShadow: `0 0 5px ${color}`,
					minHeight: '50px',
					minWidth: '50px'
				}}
			>
				{[
					recipient.recipientFirstName?.[0],
					recipient.recipientMiddleName?.[0],
					recipient.recipientLastName?.[0]
				]
					.filter(Boolean)
					.map((letter) => letter.toUpperCase())
					.join('')}
			</div>
			<div>
				<p className='recipientName' style={{ fontSize: '14px' }}>
					{[
						recipient.recipientFirstName,
						recipient.recipientMiddleName,
						recipient.recipientLastName
					]
						.filter(Boolean)
						.join(' ')}
				</p>
				<p
					className='recipientEmail'
					style={{ color: '#8E8E8E', fontSize: '12px' }}
				>
					{recipient?.recipientEmailId || recipient?.recipientEmail}
				</p>
			</div>
		</>
	);
};

export default RecipientListName;

RecipientListName.propTypes = {
	recipient: PropTypes.any
};
